import {graphql, useStaticQuery} from "gatsby";


const useIndexData = () => {
    const data = useStaticQuery(graphql`
    query MyQuery {
      strapiAbout {
        title
        description
        topCard {
          title
          description
          image {
            url
          }
          sectionPadding
        }
        iconGrid {
            title
            iconComponents {
                iconImage {
                    url
                }
                iconTitle
                iconSubTitle
            }
            backgroundShape {
            color
            shapeId
            side
            }
            sectionPadding
        }
        aboutCard {
            aboutCardText {
                title
                subTitle
            }
            aboutCardImage {
                url
            }
            backgroundShape {
                color
                shapeId
                side
            }
            sectionPadding
        }
        aboutMap {
            title
            customersNum
            employeesNum
            officesNum
            sectionPadding
        }
        aboutUsCards {
            aboutCardText {
                title
                subTitle
            }
            aboutCardImage {
                url
            }
            backgroundShape {
                color
                shapeId
                side
            }
            sectionPadding
        }
        recruit {
            title
            subtitle
            ctaText
        }
      }
      strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
        }
      }
    }`);
    return data;
};

export default useIndexData;
